module.exports = __webpack_public_path__ + "media/images/graph-2-e8c62fe62424585ff41c14ed3aa63a64.svg";